import { useState, useEffect } from "react";
import DialogComponent, { DrawerComponent, Modal } from "src/components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import { selectItem, selectItems } from "src/modules/spItems/selectors";
import { myTasksDependListName, myTasksLocationsListName } from "src/api/config/myTasksLists.config";
import { clearItem, getItem, getItems } from "src/modules/spItems/actions";
import moment from "moment";
import { myTasksIncidentCardRecipientsListName, myTasksIncidentsQuestionsListName, myTasksIncidentstListName, myTasksTypeIncidentsListName } from "src/api/config/myTasksInc.config";
import { emailsSender, equipmentsListName, paramsListName, siteUrl } from "src/api/config";
import { myTasks5WayListName, myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { useNavigate } from "react-router-dom";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Statuses from "./components/statuses";
import { TooltipItem } from "src/utils/Tooltip";
import { CancelIcon } from "src/components/ui-icons/myTasks/cancel";
import TGButton from "src/components/ui/TGButton";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import Loading from "src/components/Loading";
import LoadingOpBg from "src/components/LoadingOpBg";
import Button from "src/components/Button";
import { RootState } from "src/store/rootReducer";
import { DownloadWithHoverIcon } from "src/components/ui-icons/upload/DownloadIcon";
import { Letter } from "src/components/ui-icons/myTasks/letter";
import PptxGenJS from "pptxgenjs";
import { downloadOutlookEmailWithAttachments, urlDefault } from "src/constants";
import { emailAPI } from "src/utils/api.utils";
import html2canvas from 'html2canvas';
import { incStatus, incTypes } from "src/api/config/systemSwitch";
import { LetterFinish } from "src/components/ui-icons/myTasks/letterFinish";
const { sendEmail } = emailAPI();

const SecurityCard = ({ zIndex, open, setOpen, incidentID }: { zIndex: number, open: boolean, setOpen: any, incidentID: number }) => {
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [fields, setFields] = useState<any>([]);
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null
    });
    const [formData, setFormData] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({});
    const [customLoading, setCustomLoading] = useState(true);
    const [incQuestions, setIncQuestions] = useState<any>([]);
    const locations: any = useAppSelector(state => selectItems(state, myTasksLocationsListName));
    const dependencies: any = useAppSelector(state => selectItems(state, myTasksDependListName));
    const typesIncList: any = useAppSelector(state => selectItems(state, myTasksTypeIncidentsListName));
    const incCard: any = useAppSelector(state => selectItem(state, myTasksIncidentstListName));
    const users: any = useAppSelector(selectUsers);
    const [checkLoadUsers, setCheckLoadUsers] = useState(false);
    const [renderInc, setRenderInc] = useState(false);
    const [getInc, setGetInc] = useState(false);
    const [currentFormData, setCurrentFormData] = useState<any>(null);
    const [typesInc, setTypesInc] = useState<any>([]);
    const [currentTypeInc, setCurrentTypeInc] = useState<any>('Security');
    const [incKeys, setIncKeys] = useState<any>([]);
    const navigate = useNavigate();
    const [ID5Way, setID5Way] = useState(0);
    const [card5WayTree, setCard5WayTree] = useState<any>([]);
    const params: any = useAppSelector((state) => selectItems(state, paramsListName));
    const [cancelModal, setCancelModal] = useState(false);
    const [returnToWorkModal, setReturnToWorkModal] = useState(false);
    const [invCompletedModal, setInvCompletedModal] = useState(false);
    const [pptxLoading, setPptxLoading] = useState(false);
    const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
    const [modalEml, setModalEml] = useState(false);
    const [loadingEml, setLoadingEml] = useState(false);
    const [titleEmlPptx, setTitleEmlPptx] = useState("");
    const [incCardQuestionsEml, setIncCardQuestionsEml] = useState<any>(null);
    const [actionsEml, setActionsEml] = useState<any>([]);


    useEffect(() => {
        return () => {
            dispatch(clearItem({ listName: myTasksIncidentstListName }))
        }
    }, []);

    //Расставляем опции селектов локации, типа сотрудников
    useEffect(() => {
        if (currentUser.id && renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]['key'] === 'Location') {
                    const options = locations.filter((location: any) => {
                        if (currentUser.isSecurityAdmin || currentUser.isAdmin || (currentUser.isLocationEditorMyTasks && currentUser.isLocationEditorMyTasks.length > 0 && currentUser.isLocationEditorMyTasks.find((locationID: any) => locationID === location.ID)) || (currentUser.isLocationAdminMyTasks && currentUser.isLocationAdminMyTasks.length > 0 && currentUser.isLocationAdminMyTasks.find((locationID: any) => locationID === location.ID))) {
                            return true
                        } else {
                            return false
                        }
                    }).map((location: any) => {
                        return {
                            id: location.ID,
                            name: location.Title,
                            available: true
                        };
                    });
                    tempFieldsForm[i]['options'] = [...options];
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [locations, currentUser, renderInc]);

    useEffect(() => {
        if (renderInc) {
            if (dependenceFields["Location"]) {
                dispatch(getItems({ listName: myTasksDependListName, filters: { Location: dependenceFields["Location"]["id"] } }));
                const tempFieldsForm = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                    if (tempFieldsForm[i]["key"] === "Region") {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                }
                setFields([...tempFieldsForm]);
            }
            if (!dependenceFields["Location"]) {
                const tempFieldsForm = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region") {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                }
                setFields([...tempFieldsForm]);
            }
            if (dependenceFields["Department"]) {
                const tempFieldsForm = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                }
                setFields([...tempFieldsForm]);
            }
        }
    }, [dependenceFields, renderInc]);

    useEffect(() => {
        if (renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (dependenceFields["Location"]) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        const options = dependencies
                            .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Departament.ID,
                                    name: dependence.Departament.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
                if (dependenceFields["Department"]) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        const options = dependencies
                            .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"] && dependence.Departament.ID === dependenceFields["Department"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Region.ID,
                                    name: dependence.Region.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependencies, renderInc]);

    useEffect(() => {
        if (formData && Object.keys(formData).length > 0) {
            setCustomLoading(true);
            let tempIncObj: any = {};
            Object.keys(formData).map(key => {
                if (incKeys.some((incKey: string) => incKey === key)) {
                    if (Array.isArray(formData[key])) {
                        formData[key].sort((a: any, b: any) => {
                            return a.localeCompare(b);
                        });
                        tempIncObj[key] = formData[key];
                    } else {
                        tempIncObj[key] = formData[key];
                    }
                }
            });
            let closedDate = (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate;
            const days = Number(params.find((param: any) => param.Key === "IncSecurityDate")["Value"].trim());
            closedDate = moment(closedDate).add(days, 'days').toDate();
            const sendData = {
                ID: incidentID,
                Questions: JSON.stringify(tempIncObj),
                TypeIncident: incTypes.security,
                TimeIncident: formData.TimeIncident,
                Responsible: formData.Responsible[0]["value"],
                ResponsibleEmail: formData.Responsible[0]["value"],
                Title: `Инцидент. Security. От ${moment((typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate).format('DD.MM.YYYY')}`,
                DateIncidents: (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate,
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Description: formData.Description.trim() + " ",
                ClosedDate: closedDate
            }
            // console.log('update_sendData: ', sendData);
            updateItemRequest({ listName: myTasksIncidentstListName, body: sendData }).then((value: any) => {
                const updateIncID = value[0];
                setGetInc(!getInc);
                setCustomLoading(false);
            });
        }
    }, [formData]);

    useEffect(() => {
        if (incQuestions.length > 0) {
            let tempKeys: any = [];
            tempKeys = incQuestions.filter((field: any) => field.condition).map((field: any) => field.key);
            setIncKeys([...tempKeys]);
            setFields([...incQuestions]);
            setRenderInc(true);
        }
    }, [incQuestions]);

    useEffect(() => {
        if (currentTypeInc) {
            setRenderInc(false);
            setCustomLoading(true);
            getItemsRequest({ listName: myTasksIncidentsQuestionsListName, filters: { TypeIncident: incTypes.security }, sortOrder: { name: 'Order0', asc: true } }).then((results) => {
                const tempIncQuestions = [...results.items];
                let incFieldsForm: any = [];
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'date',
                        require: true,
                        key: 'DateIncidents',
                        title: 'Дата несоответствия/инцидента',
                        minDate: moment(new Date()).subtract(7, 'days').toDate(),
                        maxDate: moment(new Date()).toDate(),
                        placeholder: 'дд.мм.гггг',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'time',
                        require: false,
                        key: 'TimeIncident',
                        title: 'Время несоответствия/инцидента',
                        placeholder: 'чч:мм',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    }
                ]];
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'peoplePicker',
                        require: true,
                        single: true,
                        key: 'Responsible',
                        title: 'ФИО инициатора',
                        current: true,
                        condition: null,
                        placeholder: 'Введите имя или фамилию',
                        width: 'w-[calc(50%-10px)]'
                    },

                    {
                        type: 'select',
                        require: true,
                        key: 'Location',
                        title: 'Локация, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'select',
                        require: true,
                        key: 'Department',
                        title: 'Отдел, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'select',
                        require: true,
                        key: 'Region',
                        title: 'Участок, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'textArea',
                        key: 'Description',
                        require: true,
                        title: 'Описание',
                        condition: null,
                        noticeIcon: true,
                        notice: `<span class="w-full"><strong>Что?</strong> (Что случилось, в чем именно проблема?)<br/>
            <strong>Где?</strong> (Где именно проблема в продукте/процессе и где была обнаружена?) <br/>
            <strong>Когда?</strong> (Когда проблема началась, когда была обнаружена?) <br/>
            <strong>Как?</strong> (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) <br/>
            <strong>Кто?</strong> (Кто обнаружил проблему?) <br/>
            <strong>Насколько велика проблема?</strong> (Количество затронутого продукта / минуты простоя, риски от проблемы)<span>`,
                        placeholder: 'ЧТО? (Что случилось, в чем именно проблема?) ГДЕ? (Где именно проблема в продукте/процессе и где была обнаружена?) КОГДА? (Когда проблема началась, когда была обнаружена?) КАК? (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) КТО? (Кто обнаружил проблему?) НАСКОЛЬКО ВЕЛИКА ПРОБЛЕМА? (Количество затронутого продукта / минуты простоя, риски от проблемы)',
                        width: 'w-full'
                    }
                ]];
                tempIncQuestions.forEach((item) => {
                    if (item.TypeQuestion === 'select') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            title: item.Title,
                            hide: item.DefaultHide,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            width: item.Width,
                            placeholder: 'Не выбрано',
                            condition: item.Condition && JSON.parse(item.Condition),
                            options: item.Options && item.Options.split(";").map(option => {
                                return {
                                    id: option.trim(),
                                    name: option.trim()
                                }
                            }) || []
                        }]
                    } else if (item.TypeQuestion === 'radio' || item.TypeQuestion === 'checkbox') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            title: item.Title,
                            hide: item.DefaultHide,
                            width: item.Width,
                            condition: item.Condition && JSON.parse(item.Condition),
                            optionsInputs: item.Options && item.Options.split(";").map(option => option.trim()) || []
                        }]
                    } else if (item.TypeQuestion === 'number' || item.TypeQuestion === 'input') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            title: item.Title,
                            disabled: item.Disabled,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            placeholder: 'Введите значение',
                            hide: item.DefaultHide,
                            width: item.Width,
                            condition: item.Condition && JSON.parse(item.Condition),
                            default: item.Options
                        }]
                    } else if (item.TypeQuestion === "textArea") {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            title: item.Title,
                            disabled: item.Disabled,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            placeholder: 'Введите значение',
                            hide: item.DefaultHide,
                            width: item.Width,
                            condition: item.Condition && JSON.parse(item.Condition),
                            default: item.Options
                        }]
                    }
                });
                setIncQuestions([...incFieldsForm]);
                setCustomLoading(false);
            });
        } else {
            setRenderInc(true);
        }
    }, [currentTypeInc]);

    useEffect(() => {
        if (incidentID) {
            dispatch(getItem({ listName: myTasksIncidentstListName, filters: { ID: incidentID } }));
        }
    }, [incidentID, getInc]);

    useEffect(() => {
        if (incCard && Object.keys(incCard).length > 0 && !checkLoadUsers && Object.keys(users).length > 0) {
            console.log('incCard: ', incCard);
            if (incCard.AuthorEmail && incCard.ResponsibleEmail) {
                if (users[incCard.AuthorEmail] && users[incCard.ResponsibleEmail]) {
                    setCheckLoadUsers(true);
                }
            }
            let tempDefaultValues: any = {};
            Object.keys(incCard).map((key: string, idx: number) => {
                const field = incCard[key];
                if (field && (key === 'Responsible')) {
                    tempDefaultValues[key] = [
                        {
                            label: users[field.Email] && users[field.Email].displayName || field.Name,
                            value: users[field.Email] && users[field.Email].email || field.Email,
                            avatar: users[field.Email] && users[field.Email].avatar || null,
                            email: users[field.Email] && users[field.Email].email || field.Email
                        }
                    ]
                } else if (key === 'DateIncidents') {
                    tempDefaultValues[key] = {
                        startDate: field.toDate(),
                        endDate: field.toDate(),
                    }
                } else if (key === 'Location' || key === 'Department' || key === 'Region' || key === 'Status') {
                    tempDefaultValues[key] = {
                        id: field.ID,
                        name: field.Title
                    }
                } else if (key === 'AuthorEmail') {
                    return false
                } else if (key === 'Questions') {
                    if (field) {
                        const incObj = JSON.parse(field);
                        if (incObj) {
                            tempDefaultValues = { ...tempDefaultValues, ...incObj }
                        }
                    }
                } else {
                    tempDefaultValues[key] = field
                }
            });
            setDefaultValues((prevState: any) => {
                return { ...prevState, ...tempDefaultValues }
            });
            setCurrentFormData({ ...tempDefaultValues });
        }
    }, [incCard, users, checkLoadUsers]);

    useEffect(() => {
        if (incCard && Object.keys(incCard).length > 0 && currentUser.id && renderInc && fields.length > 0) {
            const tempFieldsForm = [...fields];
            if ((incCard.Status.ID === incStatus.finish || incCard.Status.ID === incStatus.cancel) || (!currentUser.isLocationEditorMyTasks || (currentUser.isLocationEditorMyTasks && !currentUser.isLocationEditorMyTasks.some((locationID: number) => locationID === incCard.Location.ID))) && (!currentUser.isLocationAdminMyTasks || (currentUser.isLocationAdminMyTasks && !currentUser.isLocationAdminMyTasks.some((locationID: number) => locationID === incCard.Location.ID)))) {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    tempFieldsForm[i]['disabled'] = true;
                }
            } else {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    tempFieldsForm[i]['disabled'] = incQuestions[i]['disabled'];
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [incCard, currentUser, renderInc, dependenceFields]);

    useEffect(() => {
        if (renderInc && currentFormData) {
            let tempCurrentFromData = { ...currentFormData, ...{ TypeIncident: "Security" } }
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                const field = tempFieldsForm[i];
                if (field.condition) {
                    let conditionObj: any = {};
                    Object.keys(field.condition).map((key: string) => {
                        if (typeof tempCurrentFromData[key] === 'object') {
                            if (tempCurrentFromData[key]['name'] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        } else {
                            if (tempCurrentFromData[key] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        }
                    });
                    if (Object.keys(field.condition).length === Object.keys(conditionObj).length) {
                        tempFieldsForm[i]['hide'] = false;
                    } else {
                        tempFieldsForm[i]['hide'] = true;
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [currentFormData, renderInc]);

    const cancelHandle = () => {
        setCancelModal(false);
        setCustomLoading(true);
        updateItemRequest({ listName: myTasksIncidentstListName, body: { ID: incidentID, Status: incStatus.cancel } }).then(results => {
            setCustomLoading(false);
            navigate(0);
        });
    }

    const returnToWorkHandle = () => {
        setReturnToWorkModal(false);
        setCustomLoading(true);
        updateItemRequest({ listName: myTasksIncidentstListName, body: { ID: incidentID, Status: incStatus.process } }).then(results => {
            if (emailsSender && incCard.ResponsibleEmail !== currentUser.email) {
                const timestamp = moment().unix();
                const emailBody = {
                    Body: `Здравствуйте ${users[incCard.ResponsibleEmail] && users[incCard.ResponsibleEmail]["displayName"]},<br/><br/>Примите во внимание, что пользователь ${currentUser.displayName} вернул в работу инцидент <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-security?securityCard=${incCard.ID}">${incCard.Title.trim()}</a>`,
                    DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                    Title: 'Мои Задачи | Возвращение в работу Инцидента',
                    Subject: 'Мои Задачи | Возвращение в работу Инцидента',
                    Recepients: incCard.ResponsibleEmail,
                    CheckDoc: String(timestamp)
                };
                Promise.all([sendEmail(emailBody)]).then(() => {
                    setCustomLoading(false);
                    navigate(0);
                });
            } else {
                setCustomLoading(false);
                navigate(0);
            }
        });
    }

    const invCompletedHandle = () => {
        setInvCompletedModal(false);
        setCustomLoading(true);
        updateItemRequest({ listName: myTasksIncidentstListName, body: { ID: incidentID, Status: incStatus.finish } }).then(results => {
            if (emailsSender && incCard.ResponsibleEmail !== currentUser.email) {
                const timestamp = moment().unix();
                const emailBody = {
                    Body: `Здравствуйте ${users[incCard.ResponsibleEmail] && users[incCard.ResponsibleEmail]["displayName"]},<br/><br/>Примите во внимание, что пользователь ${currentUser.displayName} завершил расследование инцидента <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-security?securityCard=${incCard.ID}">${incCard.Title.trim()}</a>`,
                    DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                    Title: 'Мои Задачи | Прекращение расследования инцидента',
                    Subject: 'Мои Задачи | Прекращение расследования инцидента',
                    Recepients: incCard.ResponsibleEmail,
                    CheckDoc: String(timestamp)
                };
                Promise.all([sendEmail(emailBody)]).then(() => {
                    setCustomLoading(false);
                    navigate(0);
                });
            } else {
                setCustomLoading(false);
                navigate(0);
            }
        });
    }

    const importPPTXHandle = (typeDownload: string) => {
        if (incCard && Object.keys(incCard).length > 0) {
            if (typeDownload === 'file') {
                setPptxLoading(true);
            } else {
                setLoadingEml(true);
            }
            const items = [incCard];
            const fontSize = 16;
            getItemsRequest({ listName: myTaskActionsListName, filters: { ImportantHashTag: `#инцидент_security_${incCard.ID}*` } }).then(results => {
                let actions: any = [...results.items];
                const returnItems = items.map((item: any) => {
                    let currentActions: any = [];
                    currentActions = [...currentActions, ...actions.map((action: any) => {
                        return {
                            numRoot: action.ID,
                            description: action.Description,
                            date: moment(action.DateForDone).format('DD.MM.YYYY')
                        }
                    })]
                    return {
                        ...item,
                        actions: currentActions,
                    };
                });
                const incWithActions = returnItems[0];
                const pptx = new PptxGenJS();
                pptx.defineLayout({ name: 'CUSTOM_LAYOUT', width: 22, height: 12.25 });
                pptx.layout = 'CUSTOM_LAYOUT';
                let slide = pptx.addSlide();
                let rows: any = [];
                let rowHHeight = 1;
                let pptxTitle = 'Инцидент по security';
                let incCardQuestions = incCard.Questions && JSON.parse(incCard.Questions) || null;
                rowHHeight = 3;
                rows.push([
                    { text: `#${incCard.ID}`, options: { align: "center", color: "ffffff", fill: '004465', hyperlink: { url: `${siteUrl}/dashboard/3/incidents-security?securityCard=${incCard.ID}` } } },
                    { text: `${incCard.DateIncidents.format('DD.MM.YYYY')} ${incCard.TimeIncident}`, options: { align: "center", color: "ffffff", fill: '004465', border: { type: 'solid', color: '004465' } } },
                    { text: `${pptxTitle}`.toUpperCase(), options: { align: "center", color: "ffffff", fill: '004465', border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: [3, 5, 14], w: 22, align: 'center', rowH: 0.6, fontSize: fontSize, x: 0, y: 0, valign: 'middle' });
                rows = [];
                rows.push([
                    { text: 'Локация', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } },
                    { text: 'Описание', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } },
                    { text: 'Корректирующие меры', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: [10, 7, 5], w: 22, align: 'center', rowH: 0.6, fontSize: fontSize, x: 0, y: 0.6, valign: 'middle' });
                rows = [];
                rows.push([
                    { text: 'Локация: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCard.Location.Title, options: { align: "left", border: { type: 'solid', color: '004465' } } },
                ]);
                rows.push([
                    { text: 'Отдел: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCard.Department.Title, options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                rows.push([
                    { text: 'Участок: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCard.Region.Title, options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                rows.push([
                    { text: 'ФИО инициатора: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: users[incCard.AuthorEmail] && users[incCard.AuthorEmail]['displayName'] || '-', options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: [4, 6], w: 10, align: 'center', rowH: 0.6, fontSize: fontSize, x: 0, y: 1.2, valign: 'middle' });
                rows = [];
                rows.push([
                    { text: 'Описание: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCard.Description, options: { align: "left", border: { type: 'solid', color: '004465' } } },
                ]);
                slide.addTable(rows, { colW: [3, 4], w: 7, h: 4, align: 'center', rowH: rowHHeight, fontSize: fontSize, x: 10, y: 1.2, valign: 'top' });
                rows = [];
                rows.push([
                    { text: incCardQuestions['SecurityAction'], options: { align: "left", border: { type: 'solid', color: '004465' } } },
                ])
                slide.addTable(rows, { colW: 5, w: 5, h: 4, align: 'center', rowH: rowHHeight, fontSize: fontSize, x: 17, y: 1.2, valign: 'top' });
                rows = [];
                rows.push([
                    { text: 'Классификация', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: 10, w: 10, align: 'center', rowH: 0.6, fontSize: fontSize, x: 0, y: 3.6, valign: 'middle' });
                rows = [];
                rows.push([
                    { text: fields.find((field: any) => field.key === 'SecurityTypeIncident' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityTypeIncident'] && incCardQuestions['SecurityTypeIncident']['name'] || '-', options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                rows.push([
                    { text: fields.find((field: any) => field.key === 'SecuritySubtypeIncident' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecuritySubtypeIncident'] && incCardQuestions['SecuritySubtypeIncident']['name'] || '-', options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                rows.push([
                    { text: fields.find((field: any) => field.key === 'SecurityDamage' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityDamage'] && incCardQuestions['SecurityDamage']['name'] || '-', options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                rows.push([
                    { text: fields.find((field: any) => field.key === 'SecurityIncidentReazon' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityIncidentReazon'] && incCardQuestions['SecurityIncidentReazon']['name'] || '-', options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: [4, 6], w: 10, align: 'center', rowH: 0.6, fontSize: fontSize, x: 0, y: 4.2, valign: 'middle' });
                rows = [];
                rows.push([
                    { text: 'Последствия', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: 12, w: 12, align: 'center', rowH: 0.6, fontSize: fontSize, x: 10, y: rowHHeight + 1.2, valign: 'middle' });
                rows = [];
                rows.push([
                    { text: fields.find((field: any) => field.key === 'SecurityHumanRisks' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityHumanRisks'] && incCardQuestions['SecurityHumanRisks']['name'] || '-', options: { align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: fields.find((field: any) => field.key === 'SecuritySafeCount' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecuritySafeCount'], options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                rows.push([
                    { text: fields.find((field: any) => field.key === 'SecurityPropertyRisks' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityPropertyRisks'] && incCardQuestions['SecurityPropertyRisks']['name'] || '-', options: { align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: fields.find((field: any) => field.key === 'SecurityDamageCount' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityDamageCount'], options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                rows.push([
                    { text: fields.find((field: any) => field.key === 'SecurityReputationalRisks' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityReputationalRisks'], options: { align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: fields.find((field: any) => field.key === 'SecurityRisk' && !field.hide)['title'], options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                    { text: incCardQuestions['SecurityRisk'], options: { align: "left", border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: 3, w: 12, align: 'center', rowH: 0.6, fontSize: fontSize, x: 10, y: rowHHeight + 1.8, valign: 'middle' });
                rows = [];
                rows.push([
                    { text: 'Фото', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } },
                    { text: 'Действия', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } }
                ]);
                slide.addTable(rows, { colW: [11, 11], w: 22, align: 'center', rowH: 0.6, fontSize: fontSize, x: 0, y: rowHHeight + 3.6, valign: 'middle' });
                rows = [];
                if (incWithActions.actions.length > 0) {
                    rows.push([
                        { text: '№', options: { bold: true, align: "left" } },
                        { text: 'Описание', options: { bold: true, align: "left" } },
                        { text: 'Срок выполнения', options: { bold: true, align: "left" } }
                    ]);
                    incWithActions.actions.forEach((action: any) => {
                        rows.push([
                            { text: action.numRoot, options: { align: "left" } },
                            { text: action.description, options: { align: "left" } },
                            { text: action.date, options: { align: "left" } },
                        ])
                    });
                    slide.addTable(rows, { colW: [2, 6, 3], x: 11, w: 11, y: rowHHeight + 4.2, rowH: 0.6, fontSize: fontSize, border: { type: 'solid', color: '004465' }, valign: 'middle' });
                }
                if (typeDownload === 'file') {
                    pptx.writeFile({ fileName: `${pptxTitle}_${incCard.ID}` }).then(() => {
                        setPptxLoading(false);
                    });
                }
                if (typeDownload === 'letter' || typeDownload === 'letter-finish') {
                    pptx.write({ outputType: "blob" }).then((blob) => {
                        const pptxFile = new File([blob], `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.pptx`, {
                            type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
                        });
                        setModalEml(true);
                        setTimeout(() => {
                            const elem: any = document.querySelector('#eml_template_inc');
                            html2canvas(elem, {
                                useCORS: true,
                                allowTaint: true
                            }).then(function (canvas) {
                                const urlScreen = canvas.toDataURL();
                                getItemsRequest({
                                    listName: myTasksIncidentCardRecipientsListName,
                                    filters: { Location: incCard.Location.ID, TypeIncident: incCard.TypeIncident.ID },
                                    sortOrder: { name: "ID", desc: true }
                                }).then((results) => {
                                    const emails = results.items.length > 0 && results.items[0]['Recipients'] || '';
                                    const copies = results.items.length > 0 && results.items[0]['Copies'] || '';
                                    const downloadOutlookFile = async () => {
                                        try {
                                            await downloadOutlookEmailWithAttachments({
                                                from: {
                                                    name: currentUser.displayName,
                                                    email: currentUser.email,
                                                },
                                                to:
                                                    (typeDownload === "letter" && emails &&
                                                        emails.split(",").map((email: string) => {
                                                            return {
                                                                name: email.trim(),
                                                                email: email.trim(),
                                                            };
                                                        })) ||
                                                    [],
                                                cc:
                                                    (typeDownload === "letter" && copies &&
                                                        copies.split(",").map((email: string) => {
                                                            return {
                                                                name: email.trim(),
                                                                email: email.trim(),
                                                            };
                                                        })) ||
                                                    [],
                                                subject: (typeDownload === "letter" && (
                                                    (incCard.Status.ID === incStatus.finish &&
                                                        `Отчет об инциденте ${titleEmlPptx} - ${incCard.ID}`) ||
                                                    `Уведомление об инциденте ${titleEmlPptx} - ${incCard.ID}`)) || (typeDownload === "letter-finish" && `Утверждение инцидента ${titleEmlPptx} - ${incCard.ID}`) || '',
                                                htmlBody: (typeDownload === "letter" && (
                                                    (incCard.Status.ID === incStatus.finish &&
                                                        `<p>Коллеги, здравствуйте! Во вложении отчет об <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-security?securityCard=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`) ||
                                                    `<p>Коллеги, здравствуйте! Во вложении информация о случившемся <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-security?securityCard=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`)) || (typeDownload === "letter-finish" && `<p>Здравствуйте!<br />Прошу утвердить расследование и завершить в системе <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-security?securityCard=${incCard.ID}">инцидент ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`) || "",
                                                textBody: "",
                                                attachments: [
                                                    {
                                                        name: `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.pptx`,
                                                        content: pptxFile,
                                                        mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
                                                    }
                                                ],
                                                fileName: "inc_card_report.eml"
                                            });
                                        } catch (error) {
                                            console.error("Ошибка:", error);
                                        }
                                    };
                                    downloadOutlookFile().then(() => {
                                        setLoadingEml(false);
                                        setModalEml(false);
                                    });
                                })
                            });
                        }, 5000);
                    });
                }
            });
        }
    }

    useEffect(() => {
        setLoadingEml(true);
        if (incCard && Object.keys(incCard).length > 0) {
            let incCardQuestions = incCard.Questions && JSON.parse(incCard.Questions) || null;
            setIncCardQuestionsEml(incCardQuestions);
            setTitleEmlPptx('по security');
            getItemsRequest({ listName: myTaskActionsListName, filters: { ImportantHashTag: `инцидент_security_${incCard.ID}*` } }).then((results) => {
                let actions: any = [...results.items.map((action: any, idx: number) => {
                    return {
                        idx: idx + 1,
                        description: action.Description,
                        date: moment(action.DateForDone).format('DD.MM.YYYY'),

                    }
                })];
                setActionsEml([...actions]);
                setLoadingEml(false);
            });
        }
    }, [incCard]);

    return (
        <>
            <DrawerComponent zIndex={zIndex} open={open} toggleDrawer={setOpen}>
                <div className="flex flex-col p-10 shrink">
                    {customLoading && <LoadingOpBg />}
                    {incCard && Object.keys(incCard).length > 0 &&
                        <>
                            {(currentUser.isAdmin || currentUser.isSecurityAdmin || currentUser.isSecurityEditor) &&
                                <>
                                    <FlexRow className="justify-between gap-5 mb-8 relative">
                                        <h1 className="mb-8 text-black relative break-words z-[3]">{incCard.Title}</h1>
                                        <FlexRow className="gap-[10px] absolute right-0 top-0 z-[5]">
                                            <Statuses incidentID={incidentID} />
                                            {(loadingEml || statusUsers === 'LOADING') &&
                                                <FlexCol className="h-[32px] w-[32px]">
                                                    <Loading />
                                                </FlexCol>
                                                ||
                                                <>
                                                    <TooltipItem
                                                        position="top-left"
                                                        tooltipsText={"Сформировать письмо для утверждения инцидента"}
                                                    >
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                importPPTXHandle("letter-finish");
                                                            }}
                                                            className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                        >
                                                            <LetterFinish />
                                                        </a>
                                                    </TooltipItem>
                                                    <TooltipItem position="top-left" tooltipsText={incCard.Status.ID === incStatus.finish && "Скачать письмо о результатах расследования инцидента" || "Скачать письмо о случившемся инциденте"}>
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                importPPTXHandle('letter');
                                                            }}
                                                            className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                        >
                                                            <Letter />
                                                        </a>
                                                    </TooltipItem>
                                                </>
                                            }
                                            {(pptxLoading || statusUsers === 'LOADING') &&
                                                <FlexCol className="h-[32px] w-[32px]">
                                                    <Loading />
                                                </FlexCol>
                                                ||
                                                <TooltipItem position="top-left" tooltipsText="Скачать в Power Point">
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            importPPTXHandle('file');
                                                        }}
                                                        className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                    >
                                                        <DownloadWithHoverIcon />
                                                    </a>
                                                </TooltipItem>
                                            }
                                            {incCard.Status.ID !== incStatus.cancel &&
                                                <TooltipItem position="top-left" tooltipsText={"Отменить инцидент"}>
                                                    <a

                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setCancelModal(true);
                                                        }}
                                                        className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                    >
                                                        <CancelIcon />
                                                    </a>
                                                </TooltipItem>
                                            }
                                        </FlexRow>
                                    </FlexRow>
                                    <Form
                                        type="inc_security_card_my_tasks"
                                        setFormData={setFormData}
                                        setCurrentTypeInc={setCurrentTypeInc}
                                        setCurrentFormData={setCurrentFormData}
                                        fieldsForm={[...fields]}
                                        defaultValues={defaultValues}
                                        setCard5WayTree={setCard5WayTree}
                                        setDependenceFields={setDependenceFields}
                                        incidentID={incidentID}
                                        card5WayTree={card5WayTree}
                                        ID5WayAdd={ID5Way}
                                        incLoading={customLoading}
                                        setInvCompletedModal={setInvCompletedModal}
                                    />
                                    {(incCard.Status.ID === incStatus.finish || incCard.Status.ID === incStatus.cancel) &&
                                        <FlexRow className="w-full justify-between gap-5">
                                            <Button
                                                classBg="btn-white"
                                                shadow={true}
                                                text="Закрыть"
                                                open={open}
                                                setOpen={setOpen}
                                            />
                                            {(currentUser.isAdmin || currentUser.isSecurityAdmin) &&
                                                <Button
                                                    open={returnToWorkModal}
                                                    setOpen={setReturnToWorkModal}
                                                    classBg="btn-dark"
                                                    icon={true}
                                                    typeIcon="return"
                                                    shadow={true}
                                                    text="Вернуть в работу"
                                                />
                                            }
                                        </FlexRow>
                                    }
                                </>
                                || statusUsers === "LOADING" &&
                                <div className="text-center flex flex-col items-center justify-center"><div className="mb-[20px] font-medium text-[18px] text-[#111928]">Получаем информацию о пользователе</div><div className="text-[14px] font-medium text-[#637381]">Пожалуйста, подождите...</div></div>
                                ||
                                <div className="text-center flex flex-col items-center justify-center"><div className="mb-[20px] font-medium text-[18px] text-[#111928]">У вас нет доступа к модулю Инциденты Security</div><div className="text-[14px] font-medium text-[#637381]">Пожалуйста, обратитесь к администратору</div></div>
                            }
                        </>
                    }
                </div>
            </DrawerComponent>
            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={cancelModal} toggleDialog={setCancelModal}>
                <header className="px-10 pb-4">
                    <h2>Подтвердите действие</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        Вы уверены, что хотите отменить инцидент?
                    </p>
                </div>
                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setCancelModal(!cancelModal)}>Не отменять</TGButton>
                    <TGButton color="bluedark" onClick={cancelHandle}>Да, отменить</TGButton>
                </footer>
            </Modal>
            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={returnToWorkModal} toggleDialog={setReturnToWorkModal}>
                <header className="px-10 pb-4">
                    <h2>Подтвердите действие</h2>
                </header>
                <div className="px-10 py-5">
                    <p>
                        Вы уверены, что хотите вернуть в работу инцидент?
                    </p>
                </div>
                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setReturnToWorkModal(!returnToWorkModal)}>Не возвращать</TGButton>
                    <TGButton color="bluedark" onClick={returnToWorkHandle}>Да, вернуть</TGButton>
                </footer>
            </Modal>
            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={invCompletedModal} toggleDialog={setInvCompletedModal}>
                <header className="px-10 pb-4">
                    <h2>Подтвердите действие</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        Завершить расследование инцидента?
                    </p>
                </div>
                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setInvCompletedModal(!invCompletedModal)}>Отмена</TGButton>
                    <TGButton color="bluedark" onClick={invCompletedHandle}>Да, завершить</TGButton>
                </footer>
            </Modal>
            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={modalEml} toggleDialog={setModalEml}>
                <FlexCol className="items-center justify-center w-full">
                    <span className="text-base text-darkblue block mb-5">Формируем письмо...</span>
                    <Loading />
                </FlexCol>
                {incCard && Object.keys(incCard).length > 0 && incCardQuestionsEml && fields.length > 0 &&
                    <FlexCol className="p-[25px] overflow-auto scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-w-[700px] h-[350px]">
                        <FlexCol id="eml_template_inc" className="border border-[#004465] min-w-[1920px]">
                            <FlexRow className="w-full bg-[#004465] text-[#FFFFFF] min-h-[45px] break-all items-center">
                                <FlexCol className="w-[15%] items-center justify-center mb-5 min-h-[45px] break-all">№ {incCard.ID}</FlexCol>
                                <FlexCol className="w-[15%] items-center justify-center mb-5 min-h-[45px] break-all">{`${incCard.DateIncidents.format('DD.MM.YYYY')} ${incCard.TimeIncident || ''}`}</FlexCol>
                                <FlexCol className="w-[70%] items-center justify-center mb-5 min-h-[45px] break-all">Инцидент {titleEmlPptx}</FlexCol>
                            </FlexRow>
                            <FlexRow className="w-full bg-[#00629B] text-[#FFFFFF] min-h-[45px] break-all items-center justify-between">
                                <FlexCol className="w-[33%] items-center justify-center mb-5 min-h-[45px] break-all">Локация</FlexCol>
                                <FlexCol className="w-[33%] items-center justify-center mb-5 min-h-[45px] break-all">Описание</FlexCol>
                                <FlexCol className="w-[33%] items-center justify-center mb-5 min-h-[45px] break-all">Корректирующие меры</FlexCol>
                            </FlexRow>
                            <FlexRow className="w-full">
                                <FlexCol className="w-[30%]">
                                    <FlexCol className="border-r border-[#004465] w-full px-2 pb-5">
                                        <div className="min-h-[45px] break-all flex items-center"><span className="w-[50%]"><strong>Локация:</strong></span> <span className="w-[50%]">{incCard.Location.Title}</span></div>
                                        <div className="min-h-[45px] break-all flex items-center"><span className="w-[50%]"><strong>Отдел:</strong></span><span className="w-[50%]">{incCard.Department.Title}</span></div>
                                        <div className="min-h-[45px] break-all flex items-center"><span className="w-[50%]"><strong>Участок:</strong></span><span className="w-[50%]">{incCard.Region.Title}</span></div>
                                        <div className="min-h-[45px] break-all flex items-center"><span className="w-[50%]"><strong>Ответственный:</strong></span> <span className="w-[50%]">{users[incCard.AuthorEmail] && users[incCard.AuthorEmail]['displayName'] || '-'}</span></div>
                                    </FlexCol>
                                    <FlexRow className="w-full min-h-[45px] break-all text-[#FFFFFF] items-center">
                                        <FlexCol className="border-r border-[#004465] w-full bg-[#00629B] text-[#FFFFFF] justify-center items-center min-h-[45px] break-all pb-5">Классификация</FlexCol>
                                    </FlexRow>
                                    <FlexCol className="border-r border-[#004465] px-2 gap-2 pb-5">
                                        <div className="min-h-[45px] break-all flex"><span className="w-[50%]"><strong>{fields.find((field: any) => field.key === 'SecurityTypeIncident' && !field.hide) && fields.find((field: any) => field.key === 'SecurityTypeIncident' && !field.hide)['title']}:</strong></span> <span className="w-[50%]">{incCardQuestionsEml['SecurityTypeIncident'] && incCardQuestionsEml['SecurityTypeIncident']['name'] || '-'}</span></div>
                                        <div className="min-h-[45px] break-all flex"><span className="w-[50%]"><strong>{fields.find((field: any) => field.key === 'SecuritySubtypeIncident' && !field.hide) && fields.find((field: any) => field.key === 'SecuritySubtypeIncident' && !field.hide)['title']}:</strong></span> <span className="w-[50%]">{incCardQuestionsEml['SecuritySubtypeIncident'] && incCardQuestionsEml['SecuritySubtypeIncident']['name'] || '-'}</span></div>
                                        <div className="min-h-[45px] break-all flex"><span className="w-[50%]"><strong>{fields.find((field: any) => field.key === 'SecurityDamage' && !field.hide) && fields.find((field: any) => field.key === 'SecurityDamage' && !field.hide)['title']}:</strong></span> <span className="w-[50%]">{incCardQuestionsEml['SecurityDamage'] && incCardQuestionsEml['SecurityDamage']['name'] || '-'}</span></div>
                                        <div className="min-h-[45px] break-all flex"><span className="w-[50%]"><strong>{fields.find((field: any) => field.key === 'SecurityIncidentReazon' && !field.hide) && fields.find((field: any) => field.key === 'SecurityIncidentReazon' && !field.hide)['title']}:</strong></span> <span className="w-[50%]">{incCardQuestionsEml['SecurityIncidentReazon'] && incCardQuestionsEml['SecurityIncidentReazon']['name'] || '-'}</span></div>
                                    </FlexCol>
                                </FlexCol>
                                <FlexCol className="w-[70%]">
                                    <FlexRow className="w-full h-full">
                                        <FlexCol className="border-r border-[#004465] h-full w-[50%] px-2">{incCard.Description}</FlexCol>
                                        <FlexCol className="h-full w-[50%] px-2">{incCardQuestionsEml['SecurityAction']}</FlexCol>
                                    </FlexRow>
                                    <FlexCol className="pb-5">
                                        <FlexRow className="w-full min-h-[45px] break-all text-[#FFFFFF] items-center">
                                            <FlexCol className="w-full bg-[#00629B] text-[#FFFFFF] min-h-[45px] break-all justify-center items-center pb-5">Последствия</FlexCol>
                                        </FlexRow>
                                        <FlexRow className="w-full px-2 gap-2">
                                            <FlexRow className="w-[50%] items-center gap-2">
                                                <div className="min-h-[45px] flex mr-2"><strong>{fields.find((field: any) => field.key === 'SecurityHumanRisks' && !field.hide) && fields.find((field: any) => field.key === 'SecurityHumanRisks' && !field.hide)['title']}:</strong></div>
                                                <div className="min-h-[45px] break-all flex">{incCardQuestionsEml['SecurityHumanRisks'] && incCardQuestionsEml['SecurityHumanRisks']['name'] || '-'}</div>
                                            </FlexRow>
                                            <FlexRow className="w-[50%] items-center gap-2">
                                                <div className="min-h-[45px] break-all flex mr-2"><strong>{fields.find((field: any) => field.key === 'SecuritySafeCount' && !field.hide) && fields.find((field: any) => field.key === 'SecuritySafeCount' && !field.hide)['title']}:</strong></div>
                                                <div className="min-h-[45px] break-all flex">{incCardQuestionsEml['SecuritySafeCount']}</div>
                                            </FlexRow>
                                        </FlexRow>
                                        <FlexRow className="w-full px-2 gap-2">
                                            <FlexRow className="w-[50%] items-center gap-2">
                                                <div className="min-h-[45px] break-all flex mr-2"><strong>{fields.find((field: any) => field.key === 'SecurityPropertyRisks' && !field.hide) && fields.find((field: any) => field.key === 'SecurityPropertyRisks' && !field.hide)['title']}:</strong></div>
                                                <div className="min-h-[45px] break-all flex">{incCardQuestionsEml['SecurityPropertyRisks'] && incCardQuestionsEml['SecurityPropertyRisks']['name'] || '-'}</div>
                                            </FlexRow>
                                            <FlexRow className="w-[50%] items-center gap-2">
                                                <div className="min-h-[45px] break-all flex mr-2"><strong>{fields.find((field: any) => field.key === 'SecurityDamageCount' && !field.hide) && fields.find((field: any) => field.key === 'SecurityDamageCount' && !field.hide)['title']}:</strong></div>
                                                <div className="min-h-[45px] break-all flex">{incCardQuestionsEml['SecurityDamageCount']}</div>
                                            </FlexRow>
                                        </FlexRow>
                                        <FlexRow className="w-full px-2 gap-2">
                                            <FlexRow className="w-[50%] items-center gap-2">
                                                <div className="min-h-[45px] break-all flex items-center mr-2"><strong>{fields.find((field: any) => field.key === 'SecurityReputationalRisks' && !field.hide) && fields.find((field: any) => field.key === 'SecurityReputationalRisks' && !field.hide)['title']}:</strong></div>
                                                <div className="min-h-[45px] break-all flex items-center">{incCardQuestionsEml['SecurityReputationalRisks']}</div>
                                            </FlexRow>
                                            <FlexRow className="w-[50%] items-center gap-2">
                                                <div className="min-h-[45px] break-all flex items-center mr-2"><strong>{fields.find((field: any) => field.key === 'SecurityRisk' && !field.hide) && fields.find((field: any) => field.key === 'SecurityRisk' && !field.hide)['title']}:</strong></div>
                                                <div className="min-h-[45px] break-all flex items-center">{incCardQuestionsEml['SecurityRisk']}</div>
                                            </FlexRow>
                                        </FlexRow>
                                    </FlexCol>
                                </FlexCol>
                            </FlexRow>
                            <FlexRow className="w-full bg-[#00629B] min-h-[45px] break-all text-[#FFFFFF] items-center">
                                <FlexCol className="w-[50%] min-h-[45px] break-all items-center justify-center mb-5">Фото</FlexCol>
                                <FlexCol className="w-[50%] min-h-[45px] break-all items-center justify-center mb-5">Действия</FlexCol>
                            </FlexRow>
                            <FlexRow className="w-full">
                                <div className="w-[50%] flex min-h-[45px] break-all items-center"></div>
                                {actionsEml.length > 0 &&
                                    <FlexCol className="w-[50%]">
                                        <FlexRow className="w-full">
                                            <div className="w-[15%] min-h-[45px] break-all items-center px-2"><strong>№</strong></div>
                                            <div className="w-[60%] min-h-[45px] break-all items-center px-2"><strong>Описание</strong></div>
                                            <div className="w-[25%] min-h-[45px] break-all items-center px-2"><strong>Срок выполнения</strong></div>
                                        </FlexRow>
                                        {actionsEml.map((action: any) => (
                                            <FlexRow className="w-full">
                                                <div className="w-[15%] min-h-[45px] break-all items-center px-2"><strong>{action.idx}</strong></div>
                                                <div className="w-[60%] min-h-[45px] break-all items-center px-2">{action.description}</div>
                                                <div className="w-[25%] min-h-[45px] break-all items-center px-2">{action.date}</div>
                                            </FlexRow>
                                        ))}
                                    </FlexCol>
                                }
                            </FlexRow>
                        </FlexCol>
                    </FlexCol>
                }
            </Modal>
        </>
    );
};

export default SecurityCard;
